import script from "./TutorialVideoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialVideoModal.vue?vue&type=script&setup=true&lang=js"

import "./TutorialVideoModal.vue?vue&type=style&index=0&id=b2601108&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2601108"]])

export default __exports__